import Svg, { Path, Circle } from 'react-native-svg';

export interface NewLocationMarkerProps {
  size?: number;
  primaryFill: string;
  secondaryFill: string;
}

function NewLocationMarker({
  size = 121,
  primaryFill,
  secondaryFill,
}: NewLocationMarkerProps): JSX.Element {
  return (
    <Svg
      width={size}
      height={(size * 120) / 121}
      viewBox="0 0 121 120"
      fill="none"
    >
      <Path
        d="M105.5 50C105.5 85 60.5 115 60.5 115C60.5 115 15.5 85 15.5 50C15.5 38.0653 20.2411 26.6193 28.6802 18.1802C37.1193 9.74106 48.5653 5 60.5 5C72.4347 5 83.8807 9.74106 92.3198 18.1802C100.759 26.6193 105.5 38.0653 105.5 50Z"
        fill={primaryFill}
      />

      <Circle cx={60.5} cy={50} r={18} fill={secondaryFill} />

      <Path
        d="M105.5 50C105.5 85 60.5 115 60.5 115C60.5 115 15.5 85 15.5 50C15.5 38.0653 20.2411 26.6193 28.6802 18.1802C37.1193 9.74106 48.5653 5 60.5 5C72.4347 5 83.8807 9.74106 92.3198 18.1802C100.759 26.6193 105.5 38.0653 105.5 50Z"
        stroke={primaryFill}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <Circle
        cx={60.5}
        cy={50}
        r={18}
        stroke={primaryFill}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  );
}

export default NewLocationMarker;